import React from "react";
import Pendingdesigner from "./Pendingdesigner";

export default function ViewSketchers() {
  return <Pendingdesigner type="sketcher" />;
}
